import { qualifyUrls } from "routing/Routes";
const WatchlistRoutes = {
  LIST: "/system/watchlists",
  DETAILS: (id) => `/system/watchlists/${id}`
};
const routes = qualifyUrls(WatchlistRoutes);
export default {
  ...routes,
  unqualified: WatchlistRoutes
};
